export default {"src":"/_next/static/media/Epilepsy.b666b358.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};